<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    collapse?: boolean
    horizontalScroll?: boolean
  }>(),
  {
    collapse: true,
  },
)

const app = useAppConfig()
const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const backRoute = ref('/portal')
const localePath = useLocalePath()
watchEffect(() => {
  const { path } = route

  const backPath = path.split('/').slice(2, -1).join('/')

  let currentBackRoute = localePath(`/${backPath}`)

  while (
    currentBackRoute &&
    !router.getRoutes().some((item) => item.path === currentBackRoute)
  ) {
    currentBackRoute = currentBackRoute.split('/').slice(0, -1).join('/')
  }

  backRoute.value = localePath(currentBackRoute)
})

const showNavBurger = computed(() => {
  return props.collapse && app.tairo.collapse?.toolbar?.showNavBurger
})
</script>

<template>
  <div :class="props.horizontalScroll && 'pe-4 xl:pe-10'" class="relative z-50 mb-5 flex h-16 items-center gap-2">
    <TairoCollapseBurger class="-ms-3 lg:hidden" v-if="showNavBurger" />
    <NuxtLink :to="backRoute" class="text-primary-400 flex hidden h-10 w-10 items-center justify-center lg:block"
      type="button">
      <Icon name="fluent:chevron-left-16-regular" size="35" />
    </NuxtLink>

    <BaseHeading as="h1" class="text-muted-800 hidden dark:text-white md:block" size="2xl"
      v-if="app.tairo.collapse?.toolbar?.showTitle" weight="light">
      <slot name="title">{{ t(route.meta.title) }}</slot>
    </BaseHeading>

    <div class="ms-auto"></div>
    <template v-for="tool of app.tairo.collapse?.toolbar?.tools">
      <component :is="resolveComponentOrNative(tool.component)" :key="tool.component" v-if="tool.component"
        v-bind="tool.props" />
    </template>
  </div>
</template>
